export default __webpack_public_path__ + "static/media/banner.7c65a01c.jpg";